import { BASE_URL } from "config";

import * as base from './_base';


export const endpoints = {
    list: `${BASE_URL}/api/v1/service/group/`,
    detail: (id) => `${BASE_URL}/api/v1/service/group/${id}/`,
};

export const serviceGroupListLoad = (token, payload) => base.ListLoad(endpoints.list, token, payload);
export const serviceGroupDetailLoad = (token, { id }) => base.DetailLoad(endpoints.detail, token, { id });
export const serviceGroupUpdate = (token, data) => base.Update(endpoints.list, endpoints.detail, token, data);
export const serviceGroupDelete = (token, data) => base.Delete(endpoints.detail, token, data);
